import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Button } from '../../../components/ui/button';
import { Save } from 'lucide-react';

export function FirebaseSettings({ data, setData, isSaving, onSave, IntegrationStatus }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-slate-900 font-[Poppins]">Firebase Cloud Messaging</h3>
        <IntegrationStatus enabled={data.enabled} />
      </div>
      <p className="text-sm text-slate-500 mb-6">Configure Firebase Cloud Messaging to send push notifications to users' browsers.</p>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Label>Enable Push Notifications</Label>
          <Switch checked={data.enabled} onCheckedChange={(val) => setData(prev => ({ ...prev, enabled: val }))} data-testid="firebase-enabled" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { key: 'api_key', label: 'API Key', placeholder: 'AIza...' },
            { key: 'auth_domain', label: 'Auth Domain', placeholder: 'your-app.firebaseapp.com' },
            { key: 'project_id', label: 'Project ID', placeholder: 'your-project-id' },
            { key: 'storage_bucket', label: 'Storage Bucket', placeholder: 'your-app.appspot.com' },
            { key: 'messaging_sender_id', label: 'Messaging Sender ID', placeholder: '123456789' },
            { key: 'app_id', label: 'App ID', placeholder: '1:123456789:web:abc...' }
          ].map(({ key, label, placeholder }) => (
            <div key={key}>
              <Label>{label}</Label>
              <Input placeholder={placeholder} value={data[key]} onChange={(e) => setData(prev => ({ ...prev, [key]: e.target.value }))} className="h-12 mt-1.5 font-mono text-sm" data-testid={`firebase-${key.replace(/_/g, '-')}`} />
            </div>
          ))}
        </div>
        <div>
          <Label>VAPID Key (for web push)</Label>
          <Input placeholder="BF..." value={data.vapid_key} onChange={(e) => setData(prev => ({ ...prev, vapid_key: e.target.value }))} className="h-12 mt-1.5 font-mono text-sm" data-testid="firebase-vapid-key" />
          <p className="text-xs text-slate-500 mt-1">Found in Firebase Console - Project Settings - Cloud Messaging - Web Push certificates</p>
        </div>
        <div>
          <Label>Server Key (legacy fallback)</Label>
          <Input type="password" placeholder="AAAA..." value={data.server_key} onChange={(e) => setData(prev => ({ ...prev, server_key: e.target.value }))} className="h-12 mt-1.5 font-mono text-sm" data-testid="firebase-server-key" />
          <p className="text-xs text-slate-500 mt-1">Optional legacy fallback. Prefer Service Account JSON below.</p>
        </div>
        <div>
          <Label>Service Account JSON (recommended)</Label>
          <textarea placeholder="Paste your Firebase service account JSON here..." value={data.service_account_json} onChange={(e) => setData(prev => ({ ...prev, service_account_json: e.target.value }))} className="w-full h-32 mt-1.5 font-mono text-xs border rounded-lg px-3 py-2 resize-y focus:outline-none focus:ring-2 focus:ring-amber-500" data-testid="firebase-service-account" />
          <p className="text-xs text-slate-500 mt-1">Firebase Console - Project Settings - Service Accounts - Generate New Private Key. Paste the entire JSON contents.</p>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <p className="text-sm text-blue-800"><strong>Setup Guide:</strong> Go to <a href="https://console.firebase.google.com/" target="_blank" rel="noopener noreferrer" className="underline">Firebase Console</a> - Create a project - Enable Cloud Messaging - Copy config values here. For backend notifications, download the Service Account JSON and paste it above.</p>
        </div>
      </div>
      <Button onClick={onSave} disabled={isSaving} className="mt-6 bg-slate-900 hover:bg-slate-800" data-testid="save-firebase-btn">
        <Save className="w-4 h-4 mr-2" />{isSaving ? 'Saving...' : 'Save Firebase Settings'}
      </Button>
    </div>
  );
}
